<gsp-confirmation-popup
    id="delete-rtc"
    heading="{{ 'MapViewer_RTC_Delete_Confirmation_Header' | translate }}"
    [message]="deleteConfirmationMessage"
    [confirmAction]="deleteRtcAction()"
    (cancel)="closePopup()"
></gsp-confirmation-popup>
